import { defineStore } from 'pinia'
import {
  postApiV1UserFollow,
  postApiV1Logout,
  postApiV1UserAvatar,
  putApiV1UserNickname,
} from '@/api/sdk.gen'
import { useAuthStore } from '@/stores/auth-store'

// 关注/取消关注（toggle）
async function toggleFollow(userId: number) {
  const res = await postApiV1UserFollow({ body: { follow_user_id: userId } as never })
  return res.data as { code: number; message: string }
}

// 更新头像
async function updateAvatar(avatarUrl: string) {
  const res = await postApiV1UserAvatar({ body: { avatar: avatarUrl } as never })
  const result = res.data as { code: number; message: string }
  if (result.code === 0) {
    useAuthStore().updateUser({ avatar: avatarUrl })
  }
  return result
}

// 更新昵称
async function updateNickname(nickname: string) {
  const res = await putApiV1UserNickname({ body: { nickname } as never })
  const result = res.data as { code: number; message: string }
  if (result.code === 0) {
    useAuthStore().updateUser({ username: nickname })
  }
  return result
}

// 退出登录
async function logout() {
  const authStore = useAuthStore()
  try {
    await postApiV1Logout({ body: { refresh_token: authStore.refreshToken ?? '' } as never })
  } catch {
    // 即使失败也继续清理本地状态
  }
  authStore.logout()
}

export const useUserStore = defineStore('user-store', () => {
  return { toggleFollow, updateAvatar, updateNickname, logout }
})
